import { render } from "./FacturaModal.vue?vue&type=template&id=6c5182b6&scoped=true"
import script from "./FacturaModal.vue?vue&type=script&lang=js"
export * from "./FacturaModal.vue?vue&type=script&lang=js"

import "./FacturaModal.vue?vue&type=style&index=0&id=6c5182b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5182b6"]])

export default __exports__